import { Button } from 'src/components';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  .modal-body {
    overflow-y: hidden;
    overflow-x: hidden;
    position: relative;

    .CollapsibleList {
      div {
        &:last-child {
          > div {
            overflow-y: scroll;
            max-height: 170px;
          }
        }
      }
    }
  }

  .okModalBtn {
    border: 0;
    border-radius: 20px;
    text-transform: uppercase;
    height: 38px;
    padding: 0 33px;
    cursor: pointer;
    border-width: 0;

    ${({ okBtnDisabled }) => (okBtnDisabled ? css`
      background-color: ${props => props.theme.colors.disableConsolidateBtn};
      color: ${(props) => props.theme.colors.normalButtonTextColor};
      pointer-events: none;
    ` : css`
      background-color: ${(props) => props.theme.colors.normalButtonHoverBackgroundColor};
      color: ${(props) => props.theme.colors.normalButtonHoverTextColor};
    `)}
  }

  .cancelModalBtn {
    background-color: ${(props) => props.theme.colors.clearButtonBackgroundColor};
    border: 0;
    border-radius: 20px;
    text-transform: uppercase;
    color: ${(props) => props.theme.colors.headerGroupInputsColorWhenSelected};
    height: 38px;
    padding: 0 33px;
    cursor: pointer;
    border-width: 0;

    &:hover{
      background-color: ${(props) => props.theme.colors.clearButtonHoverBackgroundColor};
      color: ${(props) => props.theme.colors.clearButtonHoverTextColor};
    }
  }

`;

export const AbsoluteContainer = styled.div`
  position: absolute;
  width: 100%;
  height: calc(100% - 20px);
  left: 0;
  top: 20px;

  border: 1px solid ${({ theme }) => theme.colors.component};
`;

export const Container = styled.div`
  display: flex;

  .inputText{
    background-color: ${(props) => props.theme.colors.modalInputSearchBackgroundColor};
  }

  padding: 20px 20px;

  flex-direction: column;
  width: 100%;
`;

export const Label = styled.div`
  color: ${(props) => props.theme.colors.UploadSurveyTitleColor};
  padding: 5px;
  font-size: 1.4em;
  margin-bottom: 10px;

  ${({ withIcon }) => (withIcon ? css`
    display: flex;

    & .icon {
      margin-right: 8.3px;
    }
  ` : '')}
`;

export const LabelSmall = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.colors.UploadSurveyTitleColor};
  font-weight: 300;

  ${({ withIcon }) => (withIcon ? css`
    display: flex;

    align-items: center;

    & .icon {
      margin-right: 8.3px;
    }
  ` : '')}
`;

export const FixedItem = styled.div`
  margin-bottom: 10px;
`;

export const TitleGroup = styled.div`
  width: 100%;
  margin-bottom: 10px;
`;

export const InputsWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  & > div {
    width: calc(75% - 10px);
    margin-right: 10px;

    .inputText {
      border-radius: 5px;
      color: ${(props) => props.theme.colors.headerGroupInputsColorWhenSelected};
    }
  }

  @media only screen and (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;

    & > div {
      width: 100%;
      margin-right: 0;
      margin-bottom: 10px;
    }

    button {
      width: 100%;
    }
  }
`;

export const ConsolidateBtn = styled(Button)`
  border-radius: 5px;
  height: 34px;
  background-color: ${(props) => props.clickable ? props.theme.colors.normalConsolidateButtonBackgroundColor : props.theme.colors.disableEvolutiveButton};
  width: 25%;

  :hover {
    background-color: ${({ theme }) => theme.colors.disableEvolutiveButton};
  }

  :active {
    background-color: ${({ theme }) => theme.colors.disableEvolutiveButton};
    border: 1px solid ${({ theme }) => theme.colors.normalConsolidateButtonBackgroundColor};
  }
`;

export const ToolTip = styled.div`
  width: 100%;
  height: 54px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.component};
  text-align: center;
`;

export const ComebackWrapper = styled.div`
  position: absolute;
  left: 24px;
  top: 16px;
  width: 97px;
  height: 24px;
  padding: 0px 10px 0px 10px;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.colors.consolidationComebackWrapper};
  border-radius: 4px;

  font-size: 1.4em;
  color: ${(props) => props.theme.colors.UploadSurveyTitleColor};

  display: flex;
  align-items: center;
  justify-content: center;

  & .icon {
    margin-right: 9.5px;
  }

  & .icon::after {
    content: '';
    height: 15px;
    width: 2px;
    color: ${({ theme }) => theme.colors.consolidationComebackWrapper};
  }
`;
